import _t from 'i18n!nls/ent-website';

export const getValuePropCardData = () => ({
  header: _t('Develop career skills and credentials to stand out'),
  bullets: [
    _t('Build in demand career skills with experts from leading companies and universities'),
    _t('Choose from over #{courseCount} courses, hands-on projects, and certificate programs', { courseCount: 8000 }),
    _t('Learn on your terms with flexible schedules and on-demand courses'),
  ],
  ctaText: _t('Join for Free'),
  ctaButtonAriaLabel: _t('Join Coursera for free'),
});

// Corresponds to the content type id in Contentful
export const enterpriseArticleRichTextEmbedTypes = {
  articleHighlight: 'EnterpriseArticlesHighlight',
  articlePromoUnit: 'EnterpriseArticlesPromoUnit',
  articleInlinePromoUnit: 'EnterpriseArticlesInlinePromoUnit',
  articleNativeAd: 'EnterpriseArticlesNativeAd',
  articleVideo: 'EntWebsiteVideo',
} as const;
